import { inject, Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';
import { CompanyRoleModel } from '../models/company-role.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CompaniesService } from './company.service';
import { environment } from '../../environments/environment';
import { ResourceType } from '../enums/resource-type.enum';
import { ActionType } from '../enums/action-type.enum';

@Injectable({
	providedIn: 'root',
})
export class GrantService extends GenericService<any> implements OnDestroy {
	private subscription: Subscription[] = [];
	private activeCompany: any = null;
	private http1 = inject(HttpClient);
	private companiesService = inject(CompaniesService);

	constructor() {
		super();
		this.endpoint = 'users/me';
		this.ACTIONS = {
			list: 'ROLE_LIST',
			add: 'ROLE_ADD',
			update: 'ROLE_UPDATE',
			delete: 'ROLE_DELETE',
			item: 'ROLE_ITEM',
		};

		this.subscription.push(
			this.companiesService.company$.subscribe({
				next: (res) => {
					if (res && res?.uuid && (!this.activeCompany || this.activeCompany.uuid !== res.uuid)) {
						this.activeCompany = res;
						this.getRole().subscribe({
							next: (roleRes: any) => {
								const role = roleRes.userRolesCompanies.find((r: any) => r.company?.uuid === this.activeCompany.uuid);
								this.role$.next(role);
							},
						});
					}
				},
			})
		);
	}
	public role$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	getRole(): any {
		return super.list(this.endpoint);
	}

	ngOnDestroy(): void {
		this.subscription.forEach((sub) => sub.unsubscribe());
	}

	getGrant(resource: ResourceType, action: ActionType): boolean {
		return true; //Temporary bypass
		const role = this.role$.value;
		if (!role) return false;
		if (role.isOwner) return true;

		const grantlist = role.role?.grantlist ?? [];
		return grantlist.some((grant: any) => grant.resource === resource && grant.action.includes(action));
	}
}
